import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Loan } from "./loan";
import { Loanscheme } from "../../master/loan/shared/loanscheme.model";
import { Loanreceipt } from "./loanreceipt";
import { Installments } from "./installments.model";
import { Ledger} from "../../master/ledger/shared/ledger";

@Injectable({
  providedIn: 'root'
})
export class LoanService {

  public selectedLoan: Loan;
  public SelectedLoanscheme: Loanscheme;
  public LoanList: Loan[];
  public selectedLoanreceipt: Loanreceipt;
  public selectedInstallments: Installments;
  public selectedLedger: Ledger;

  constructor(private httpClient: HttpClient) {
  }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDLoan(loan: any) {

    loan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    loan.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    loan.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]
    let body = loan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/IUD', body, { headers: headers });
  }

  FetchLoanByLoanNo(loan: Loan) {
    loan.IsCustomerSearch = false; // it is used for handling SP , LoanApproval.
    let body = loan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Fetch', body, { headers: headers });
  }

  LoanApprovalByLoanNo(loan: any) {
    this.selectedLoan = new Loan();
    this.selectedLoan.Id =+ loan.Id;
    this.selectedLoan.LoanApprovedStatusId = loan.LoanApprovedStatusId;
    this.selectedLoan.IsCustomerSearch = loan.IsCustomerSearch; 
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    
    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Fetch', body, { headers: headers });
  }

  FetchLoanList(loan: any) {

    this.selectedLoan = new Loan();
    this.selectedLoan.SearchByApprovedStatus = loan.SearchByApprovedStatus;  // search criteria
    this.selectedLoan.LoanApprovedStatusId = loan.LoanApprovedStatusId;
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/FetchList', body, { headers: headers });
  }

  FetchScheme() {

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Scheme', body, { headers: headers });
  }

  FetchSchemeBySchemeId(schemeId: number) {

    this.SelectedLoanscheme = new Loanscheme();
    this.SelectedLoanscheme.Id = schemeId;
    this.SelectedLoanscheme.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.SelectedLoanscheme.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.SelectedLoanscheme.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.SelectedLoanscheme.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.SelectedLoanscheme;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanScheme/Fetch', body, { headers: headers });
  }

  FetchLoanType() {
    // var body = JSON.stringify('');
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post( this.getBaseUrl() +  'api/CommonMaster/LoanType', body, requestOptions).map(x => x.json());

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanType', body, { headers: headers });
  }

  FetchLoanPurpose() {
    // var body = JSON.stringify('');
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post( this.getBaseUrl() +  'api/CommonMaster/LoanPurpose', body, requestOptions).map(x => x.json());
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanPurpose', body, { headers: headers });
  }

  FetchAgentList() {

    this.selectedLoan = new Loan();
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Agent', body, { headers: headers });
  }

  FetchAutogeneratedNumber() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AutoGeneratedNumber', body, { headers: headers });
  }

  FetchCustomerList() {

    this.selectedLoan = new Loan();
    this.selectedLoan.IsCustomerSearch = true;
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  }

  GetCustomerAddressById(CustomerId: any) {

    this.selectedLoan = new Loan();
    this.selectedLoan.Id = CustomerId;
    this.selectedLoan.IsCustomerSearch = true;
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/Fetch', body, { headers: headers });
  }

  //----------------------------// Loan Reports  //----------------------------//

  FetchReportsLoanList(rptSearchData: any) {
    this.selectedLoan = new Loan();
    // this.selectedLoan.ReportName ="LoanReport";
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.FromDate = rptSearchData.LoanFromDate;
    this.selectedLoan.ToDate = rptSearchData.LoanToDate;
    this.selectedLoan.SchemeId = rptSearchData.SchemeId;
    this.selectedLoan.LoanTypeId = rptSearchData.LoanTypeId;
    this.selectedLoan.loanCategoryId = rptSearchData.LoanCategoryId;
    this.selectedLoan.LoanApprovedStatusId = rptSearchData.StatusId;
    this.selectedLoan.BranchId = rptSearchData.BranchId;
    this.selectedLoan.CentreId = rptSearchData.CentreId;

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }

  FetchReportsDemandSheet(rptSearchData: any) {

    this.selectedLoan = new Loan();
    // this.selectedLoan.ReportName ="LoanReport";
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.ToDate = rptSearchData.LoanToDate;
    this.selectedLoan.BranchId = rptSearchData.BranchId;
    this.selectedLoan.CentreId = rptSearchData.CentreId;
    this.selectedLoan.IsCentreORCustomerWise = rptSearchData.IsCentreORCustomerWise;

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }
  

  //----------------------------// FetchLoanreceiptList  //----------------------------//

  FetchLoanreceiptList() {

    this.selectedLoanreceipt = new Loanreceipt();
    this.selectedLoanreceipt.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoanreceipt.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoanreceipt.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoanreceipt.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    //   var body = JSON.stringify(this.selectedLoanreceipt);
    //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    //   return this.http.post( this.getBaseUrl() +  'api/LoanReceipt/FetchList', body, requestOptions).map(x => x.json());

    let body = this.selectedLoanreceipt;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanReceipt/FetchList', body, { headers: headers });
  }

  IUDLoanReceipt(loanreceipt: Loanreceipt) {

    loanreceipt.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loanreceipt.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loanreceipt.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loanreceipt.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    //   var body = JSON.stringify(loanreceipt);
    //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    //   return this.http.post(this.getBaseUrl() + 'api/LoanReceipt/IUD', body, requestOptions).map(x => x.json());
    let body = loanreceipt;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanReceipt/IUD', body, { headers: headers });
  }


  FetchPaymentMode() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/PaymentMode', body, { headers: headers });
  }


  FetchInstallmentsList(loanId: any) {

    this.selectedInstallments = new Installments();

    this.selectedInstallments.LoanId =+ loanId;
    this.selectedInstallments.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedInstallments.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedInstallments.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedInstallments.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedInstallments;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Installments/FetchList', body, { headers: headers });
  }

  
  FetchBankLedgerList(){
    
    this.selectedLedger  = new Ledger();
    this.selectedLedger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLedger.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedLedger.IsBranchWise = true;

    let body =  this.selectedLedger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Ledger/FetchList', body,{headers: headers});
   }

}
